<div class="mat-simple-snackbar" *ngIf="showConnectionMessage">
  <div class="connection-messages" *ngIf="data?.info; else plain">
    <table>
      <thead>
        <tr>
          <th>{{ data.message }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data?.info?.items">
          <td>{{ item }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #plain>
    <span>{{ data.message }}</span>
  </ng-template>
  <span class="filler"></span>
  <div class="mat-simple-snackbar-action">
    <button mat-button (click)="closeConnectionMessage()">
      <mat-icon aria-hidden="false" aria-label="Error" class="connection_icon">signal_wifi_off</mat-icon>
    </button>
  </div>
</div>
